<div class="modal-form-body">
    <div class="grid">
        <div class="col-12">
            <label for="formName" class="modal-label">Form name</label>
            <input
                id="formName"
                type="text"
                pInputText
                [(ngModel)]="formName"
                placeholder="Enter form name"
                class="w-full"
                [disabled]="loading"
                (keyup.enter)="createForm()" />
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="modal-btn-cancel" (click)="cancel()" [disabled]="loading">Cancel</button>
    <button type="button" class="modal-btn-primary" (click)="createForm()" [disabled]="!formName.trim() || loading">
        {{ loading ? 'Creating...' : 'Create form' }}
    </button>
</div>
